import { render, staticRenderFns } from "./CommentInputBlock.vue?vue&type=template&id=6f4b82fa&scoped=true"
import script from "./CommentInputBlock.vue?vue&type=script&lang=js"
export * from "./CommentInputBlock.vue?vue&type=script&lang=js"
import style0 from "./CommentInputBlock.vue?vue&type=style&index=0&id=6f4b82fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4b82fa",
  null
  
)

export default component.exports